import { render, staticRenderFns } from "./LeyesPromulgadas.vue?vue&type=template&id=e23fc854&scoped=true&"
import script from "./LeyesPromulgadas.vue?vue&type=script&lang=js&"
export * from "./LeyesPromulgadas.vue?vue&type=script&lang=js&"
import style0 from "./LeyesPromulgadas.vue?vue&type=style&index=0&id=e23fc854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23fc854",
  null
  
)

export default component.exports